import { render } from "./spinner.vue?vue&type=template&id=097a98d0"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/bootstrap/spinner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "097a98d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('097a98d0', __exports__)) {
    api.reload('097a98d0', __exports__)
  }
  
  module.hot.accept("./spinner.vue?vue&type=template&id=097a98d0", () => {
    api.rerender('097a98d0', render)
  })

}


export default __exports__